import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AuthService } from 'AuthService';
import { AjaxService } from 'AjaxService';
import { Subscription } from 'rxjs';
import { ServerPollService, ICountsViewModel } from 'ServerPollService';
import { FaqPopupComponent } from '@shared/faq-popup/faq-popup.component';
import { DxLoadPanelComponent } from 'devextreme-angular/ui/load-panel';
import { HanduchPopupComponent } from '@shared/handuch-popup/handuch-popup.component';
@Component({
    selector: 'nav-menu',
    templateUrl: './navmenu.component.html',
    styleUrls: ['./navmenu.component.css'],
    standalone: false
})
export class NavMenuComponent implements OnInit, OnDestroy {
  @ViewChild('faqPopup', { static: false }) faqPopup: FaqPopupComponent;
  @ViewChild('handbuchPopup', { static: false }) handbuchPopup: HanduchPopupComponent;
  @ViewChild('loadPanel', { static: false }) loadPanel: DxLoadPanelComponent;

  userName: string;
  version: string;
  counts: ICountsViewModel = {} as ICountsViewModel;
  private sub1: Subscription;

  constructor(private ajaxService: AjaxService, private authService: AuthService, private serverPollService: ServerPollService) {
  }

  ngOnInit(): void {
    this.version = this.authService.getVersion();

    const names = this.authService.getNames();
    this.userName = names.name + ', ' + names.vorname;

    this.sub1 = this.serverPollService.init().subscribe(response => {
      this.counts = response;
    });
  }

  ngOnDestroy(): void {
    if (this.sub1) {
      this.sub1.unsubscribe();
    }
  }

  onClickLogout() {
    this.serverPollService.Stop();
    this.authService.logout();
  }

  onClickFAQ(e) {
    this.faqPopup.open();
  }

  onClickHandbuch(e) {
    this.handbuchPopup.open();
  }

  onClickGesamtuebersichtTraeger(e) {
    this.loadPanel.instance.show().then(() => {
      this.ajaxService.postDownload('api/Traeger/GesamtuebersichtTraeger', 'Gesamtübersicht.pdf', null, () => {
        this.loadPanel.instance.hide();
      });
    });
  }
}
